export default __webpack_public_path__ + "static/media/st.02a19c7f.svg";